import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { Services } from "@/components/site/Services";
import { About } from "@/components/site/About";
import { FamilyBand } from "@/components/site/FamilyBand";
import { Gallery } from "@/components/site/Gallery";
import { Reviews } from "@/components/site/Reviews";
import { QuoteForm } from "@/components/site/QuoteForm";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";

export default function Home() {
  return (
    <div className="bg-white" data-testid="home-page">
      <Navbar />
      <main>
        <Hero />
        <Services />
        <About />
        <FamilyBand />
        <Gallery />
        <Reviews />
        <QuoteForm />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
